// client/src/utils/assets.js
// Resolve server-hosted asset URLs
const API_BASE =
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api');
const ASSET_BASE = API_BASE.replace(/\/api\/?$/, '');

export function resolveAssetUrl(url) {
    if (!url) return '';
    if (/^data:/i.test(url)) {
        return url;
    }
    if (/^https?:\/\//i.test(url)) {
        return url;
    }
    const normalized = url.startsWith('/') ? url : `/${url}`;
    return `${ASSET_BASE}${normalized}`;
}
